module.exports = __webpack_public_path__ + "media/images/pic/organization-395c961d49fc40db6fe3e66a4c40d695.svg";